import Axios from "axios";
import { loadCSS, loadScript } from "./util";

/**
 * 根据live2d骨骼文件，判断需要加载的spine-player版本
 * @param {*} skelUrl
 * @param {*} jsonUrl
 * @returns
 */
export async function getSpinePlayer(skelUrl, jsonUrl) {
  if (!skelUrl && !jsonUrl) {
    throw new Error("spine player加载错误：skelUrl or jsonUrl is null");
  }

  // 获取包含版本号的字符串
  let versionString = "";
  if (skelUrl) {
    const response = await Axios.get(skelUrl, { responseType: "blob" });
    const blob = response.data;
    versionString = await blob.slice(0, 16).text();
  } else if (jsonUrl) {
    const response = await Axios.get(jsonUrl);
    const json = response.data;
    versionString = json.skeleton.spine;
  }

  // 定义版本与资源的映射表
  const versionMap = {
    "4.0": {
      css: "spine-player-4.0.30.css",
      js: "spine-player-4.0.30.js",
      globalVar: "spine_4_0_30"
    },
    "4.1": {
      css: "spine-player-4.1.54.css",
      js: "spine-player-4.1.54.js",
      globalVar: "spine_4_1_54"
    },
    "4.2": {
      css: "spine-player-4.2.82.css",
      js: "spine-player-4.2.82.js",
      globalVar: "spine_4_2_82"
    }
  };

  // 匹配版本号
  const matchedVersion = Object.keys(versionMap).find(version => new RegExp(`${version}\\.\\d+`).test(versionString));

  if (!matchedVersion) {
    throw new Error(`spine player无法加载：不支持的版本 ${versionString}`);
  }

  const { css, js, globalVar } = versionMap[matchedVersion];

  // 加载 CSS 和 JS， 同步加载
  await Promise.all([
    loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/${css}?t=10001`),
    loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/${js}?t=10001`)
  ]);

  // 延迟, 等待事件周期完成
  await new Promise(resolve => setTimeout(resolve, 0));

  // 返回全局变量
  if (window[globalVar]) {
    return window[globalVar];
  } else {
    throw new Error(`spine player加载失败：全局变量 ${globalVar} 未定义`);
  }
}
